<div class="pages-registration-container">
  <div class="page-registration-content">
    <div class="page-registration-content-header">
      @if (logo) {
        <div class="align-center">
          <img class="public-logo img-width100" ngSrc="assets/images/{{logo}}" alt="" width="286" height="76"
               [priority]="true"/>
        </div>
      }
    </div>
    <div class="page-registration-content-body margin-top-5">
      <form [formGroup]="mainForm">
          <h1>Email Verification</h1>
          <div class="p-grid p-fluid no-margin">
            @if(!isProcessed) {
              <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
                <label class="registration-label">Email<sup class="req">*</sup></label>
                <!--        <input type="text" class="margin-bottom-5" pInputText formControlName="email"/>-->
                <input type="text" class="margin-bottom-5" pInputText formControlName="email" tabindex="0" >
                @if (mainForm.get('email').dirty && mainForm.get('email').errors?.required) {
                  <span class="p-error">Email is required</span>
                }
                @if (mainForm.get('email').dirty && mainForm.get('email').errors?.email) {
                  <span class="p-error">Valid Email is required</span>
                }
              </div>

              <div class="next-page-button">
                @if (!isSaving) {
                  <p-button label="Submit" (click)="validateEmail()" [disabled]="mainForm.invalid"/>
                }
                @if (isSaving) {
                  <p-button  label="Submit" class="p-button-info export-excel p-mr-2" [className]="'inline-button'"
                          [disabled]="true">
                    <i class="pi pi-spin pi-spinner save-spinner"></i>
                  </p-button>
                }
              </div>
            } @else {
              <h3 class="text-align-middle">
                A verification email has been sent. Please check your inbox (and spam folder) for the link to confirm your email.
              </h3>
            }

          </div>
      </form>
    </div>
  </div>
</div>
